module.exports = __webpack_public_path__ + "img/13.38c1db2f.png";